
import Vue from 'vue';
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { BoListPanel } from 'bonomo/dist';
import PaginationBar from '@/components/shared/PaginationBar.vue';
import { BetterDataTableHeader } from '@/model/betterVuetifyInterfaces';
import { IShortBusinessClient } from '@/model/BusinessClient/businessClientInterfaces';
import { IAuthUserData } from '@/store/modules/authModule';
import { EPermissionActions } from '@/model/EPermissionActions';
import CreateButton from '@/components/shared/CreateButton.vue';

const clientModule = namespace('clientModule');
const authModule = namespace('authModule');

@Component({
  components: { BoListPanel, PaginationBar, CreateButton },
})
export default class BusinessClientList extends Vue {
  @clientModule.Getter('businessClientList')
  private clientList!: IShortBusinessClient[];

  @clientModule.Getter('currentPage')
  private currentPage!: number;

  @clientModule.Getter('lastPage')
  private lastPage!: number;

  @clientModule.Getter('total')
  private total!: number;

  @clientModule.Getter('perPage')
  private perPage!: number;

  @clientModule.Action('fetchBusinessClients')
  private fetchClients!: (filters: any) => Promise<any>;

  @clientModule.Action('clearBusinessClients')
  private clearBusinessClients!: () => void;

  @authModule.Getter('userData')
  protected authUser!: IAuthUserData;

  private search: string = '';
  private selectedPerPage: number = 15;
  private searchTimer: any = null;

  readonly perPageOptions: number[] = [15, 30, 50, 100];

  get canCreate(): boolean {
    return this.$canAction(EPermissionActions.ACTION_BUSINESS_CLIENTS_CREATE);
  }

  get headers(): BetterDataTableHeader[] {
    return [
      { text: this.$t('common.id') as string, align: 'start', sortable: true, value: 'id' },
      { text: this.$t('common.name') as string, align: 'start', sortable: true, value: 'name' },
      { text: this.$t('clients.fields.legalName') as string, align: 'start', sortable: true, value: 'legal_name' },
      { text: this.$t('clients.stats.communities') as string, align: 'center', sortable: false, value: 'communities_count' },
      { text: this.$t('clients.stats.lockers') as string, align: 'center', sortable: false, value: 'lockers_count' },
      { text: this.$t('clients.stats.standalones') as string, align: 'center', sortable: false, value: 'standalones_count' },
      { text: this.$t('clients.stats.users') as string, align: 'center', sortable: false, value: 'users_count' },
      { text: '', value: 'detailButton', sortable: false },
    ];
  }

  loadData() {
    this.fetchClients(this.buildFilters());
  }

  mounted() {
    this.loadData();
  }

  private buildFilters(): any {
    const filters: any = { page: 1, per_page: this.selectedPerPage };
    if (this.search) filters.search = this.search;
    return filters;
  }

  onSearchInput() {
    clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => {
      this.reload();
    }, 400);
  }

  onClearSearch() {
    this.search = '';
    this.reload();
  }

  private reload() {
    this.clearBusinessClients();
    this.fetchClients(this.buildFilters());
  }

  onPageChange(page: number) {
    this.clearBusinessClients();
    const filters: any = this.buildFilters();
    filters.page = page;
    this.fetchClients(filters);
  }

  onPerPageChange(value: number) {
    this.selectedPerPage = value;
    this.reload();
  }
}
